import {EmailActions} from '../../actions/EmailActions';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import {EmailThreadContentDto} from '../../domain/EmailContentDto';
import "./ArchiveSettingsDialog.scss";
import {DateField} from "../common/DateField";
import {dateTimeFromNullableTicks, ticksFromNullableDateTime, UtcZone} from "../../util/DateHelper";
import {DateTime} from "luxon";
import {getItemContent} from "../../state/ItemState";
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";

const ArchiveSettingsDialog = () => {

    const emailContentId = useAppSelector(s => (getItemContent(s.itemState) as EmailThreadContentDto).Id);
    const open = useAppSelector(s => s.itemState.showArchiveSettingsDialog);
    const autoArchiveDate = useAppSelector(s => s.itemState.autoArchiveDate);

    const dispatch = useAppDispatch();

    function handleDateChange() {
        EmailActions.setAutoArchiveDateOnEmails([emailContentId], autoArchiveDate)(dispatch);
        onClose();
    }

    function setSelectedDate(date: DateTime | null) {
        dispatch(EmailActions.setAutoArchiveDate(ticksFromNullableDateTime(date, UtcZone)));
    }

    function onClose() {
        dispatch(EmailActions.hideArchiveSettingsDialog());
    }

    return (
        <Dialog open={open} onClose={onClose}>

            <DialogTitle id="alert-dialog-title">Auto Archive Settings</DialogTitle>
            <DialogContent className="edit-email-category-dialog">

                <div>Select the automatic archival date below:</div>

                <DateField label=" "
                           fullWidth
                           value={dateTimeFromNullableTicks(autoArchiveDate, UtcZone)}
                           onChange={newDate => setSelectedDate(newDate)}/>

                <div>&nbsp;</div>
            </DialogContent>

            <DialogActions className="archive-dialog-buttons">
                <Button onClick={handleDateChange} color="primary" variant="contained">OK</Button>
                <Button onClick={onClose} color="secondary" variant="contained">Cancel</Button>
            </DialogActions>

        </Dialog>
    );
}

export default ArchiveSettingsDialog;
